import { render } from "./MediaLayout.vue?vue&type=template&id=6ff09122&scoped=true&ts=true"
import script from "./MediaLayout.vue?vue&type=script&lang=ts"
export * from "./MediaLayout.vue?vue&type=script&lang=ts"

import "./MediaLayout.vue?vue&type=style&index=0&id=6ff09122&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff09122"]])

export default __exports__